import { render, staticRenderFns } from "./Cderma2021.vue?vue&type=template&id=0daa6b96"
import script from "./Cderma2021.vue?vue&type=script&lang=ts"
export * from "./Cderma2021.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports